import { getAuthToken } from './user';
import { getDeployment } from './config';
import { postItemRemovalResponse } from '@/redux/api/itemRemoval';
import { toast } from '@liveauctioneers/caterwaul-components/lib/ToastMessage/ToastMessageTemplate';

/* Action Types */
const SUBMIT_ITEM_REMOVAL_RESPONSE_FAIL = 'SUBMIT_ITEM_REMOVAL_RESPONSE_FAIL';
const SUBMIT_ITEM_REMOVAL_RESPONSE_REQUEST = 'SUBMIT_ITEM_REMOVAL_RESPONSE_REQUEST';
const SUBMIT_ITEM_REMOVAL_RESPONSE_SUCCESS = 'SUBMIT_ITEM_REMOVAL_RESPONSE_SUCCESS';

// reducer
export const DEFAULT_STATE = {
    error: false,
    errorMessage: '',
    submitted: false,
    success: false,
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case SUBMIT_ITEM_REMOVAL_RESPONSE_FAIL:
            return {
                ...state,
                error: true,
                errorMessage: action.payload,
                submitted: false,
                success: false,
            };
        case SUBMIT_ITEM_REMOVAL_RESPONSE_REQUEST:
            return {
                ...state,
                error: false,
                errorMessage: '',
                submitted: true,
                success: false,
            };
        case SUBMIT_ITEM_REMOVAL_RESPONSE_SUCCESS:
            return {
                ...state,
                error: false, // TODO: remove
                errorMessage: '', // TODO: remove
                submitted: false,
                success: true,
            };
        default:
            return state;
    }
}

/* SELECTORS */

/* ACTION CREATORS */
export const sumbitAcceptItemRemovalResponse =
    (action: 'accept' | 'decline', lotId: string, verificationCode: string, timestamp: string) =>
    async (dispatch: Function, getState: Function) => {
        try {
            const state = getState();
            const authToken = getAuthToken(state);
            const deployment = getDeployment(state);
            dispatch({
                type: SUBMIT_ITEM_REMOVAL_RESPONSE_REQUEST,
            });
            const response = await postItemRemovalResponse({
                authToken,
                deployment,
                lotId,
                response: action === 'accept' ? 'agree' : 'no', // 'agree' || 'no'
                timestamp,
                verificationCode,
            });
            dispatch({
                type: SUBMIT_ITEM_REMOVAL_RESPONSE_SUCCESS,
            });
            toast(response.message, {
                autoClose: false,
            });
        } catch (error) {
            dispatch({
                error: true,
                payload: error,
                type: SUBMIT_ITEM_REMOVAL_RESPONSE_FAIL,
            });
        }
    };
